import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { WorkflowLayout } from 'Components/ComponentLibrary/Organisms/WorkflowLayout/WorkflowLayout';
import { FDContentContainer } from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { AccountOpeningV2PersonalInformationStepLayout } from './layout';
import { metaOverrideSet } from './metaOverrideSet';

export const AccountOpeningV2PersonalInformationStepTemplate = ({ resource }) => {
  const { setPageContentCollection, loadPageContentLink } = usePageContentContext();
  return (
    <WorkflowLayout appearance="elevated" resource={resource}>
      <FDContentContainer maxWidth="sm">
        <MetaResourceRenderer
          metaOverrideSet={metaOverrideSet}
          layout={AccountOpeningV2PersonalInformationStepLayout}
          LayoutProps={{ navigateToLink: loadPageContentLink }}
          resource={resource}
          onSubmit={setPageContentCollection}
        />
      </FDContentContainer>
    </WorkflowLayout>
  );
};

AccountOpeningV2PersonalInformationStepTemplate.defaultProps = {
};

AccountOpeningV2PersonalInformationStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
